import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./QuoteBlock.css";

interface QuoteBlockProps {
  description: string;
}

export const QuoteBlock = (props: QuoteBlockProps) => {
  return (
    <>
      <Container fluid className="quoteBlockContainer">
        <Row>
          <Col>
            <div className="quoteBlockPadding">
              <h2 style={{ color: 'white' }}>{props.description}</h2>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
